var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComment1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0252 9.46374H24.0378V10.9779C24.0378 14.101 21.4826 16.5615 18.3596 16.5615H10.0315L7.66558 18.9275V20.347C7.66558 22.5236 9.46374 24.3218 11.6404 24.3218H20.6309L26.4038 30V24.3218C28.3911 24.1325 30 22.4291 30 20.347V13.4385C30 11.2618 28.2019 9.46374 26.0252 9.46374ZM4.06936 0H18.3596C20.6309 0 22.4291 1.7981 22.4291 4.06936V10.9779C22.4291 13.1546 20.6309 14.9527 18.3596 14.9527H9.3691L3.59623 20.6309V14.9527C1.60883 14.7634 0 13.06 0 10.9779V4.06936C0 1.7981 1.7981 0 4.06936 0Z",
    fill: "#061240"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment1);
export default __webpack_public_path__ + "static/media/comment-1.a86cece9.svg";
export { ForwardRef as ReactComponent };